import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { Trans } from "react-i18next";

class GeoProjects extends Component {
  render() {
    return (
      <Container>
        <div className="services-content row">
          <p>GeoProjects</p>
        </div>
      </Container>
    );
  }
}

export default GeoProjects;
